export default {
    GET_APP_TEXT : 'Get app',
    DOWNLOAD_APP_TEXT : 'Download app',
    DOWNLOAD_APP_DESC : "Download the LiveAldar app for a better experience"
}